<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="vendorCheck">Se ha enviado un código de confirmación al correo asociado a su cuenta.</label>
    <button class="btn btn-primary generalPrimaryButton float-right" data-dismiss="modal" aria-label="Close" @click="accept()">Aceptar</button>
  </Modal>
</template>

<script>
import Modal from '../../Shared/Modal.vue';
export default {
  name: 'InfoOTP',
  props: [
    'id',
    'modalTitle',
    'class',
  ],
  data() {
    return {
      classes: this.class,
    }
  },
  components: {
    Modal,
  },
  methods: {
    accept(){
      this.$router.push({ name: 'resetPassword' })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
